import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../../../common'
import * as enums from '../enums'

export const DOC = gql`
  ${common.gql.values.fragments.valueWithInfo.DOC}
  fragment FragmentGeneralLedgerFilterComparison on GeneralLedgerFilterComparison {
    attributeId
    operator
    value {
      ...FragmentValueWithInfo
    }
    __typename
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentGeneralLedgerFilterComparisonFragment,
  ents.extra.rate.gl.Filter.Comparison
>({
  attributeId: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.models.Attribute.Id.assertIsId,
    { warnOnly: true },
  ),
  operator: graphql.transformers.OUT.validate(
    enums.comparisonOperator.TRANSFORMER,
    ents.extra.rate.gl.Filter.Comparison.Operator.assertIsOperator,
    { warnOnly: true },
  ),
  value: graphql.transformers.OUT.validate(
    graphql.transformers.OUT.pipe(
      common.gql.values.fragments.valueWithInfo.TRANSFORMER,
      graphql.transformers.OUT.select('raw', transformers.PASS_THROUGH),
    ),
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
})
